import { api } from "assets/scripts/utilities/api-clients";

export const getCount = async (options = {}) => {
  const response = await api.get("kam/notifications-count", options);

  return response;
};

export const index = async (options = {}) => {
  const response = await api.get("kam/notifications", options);

  return response;
};

export const post = async (notification) => {
  const response = await api.post("kam/notifications", notification);

  return response;
};

export const put = async (notification) => {
  const response = await api.put("kam/notifications", notification);

  return response;
};
